import React, { ReactNode } from 'react';
import { usePermission } from '@/lib/contexts/permission-context';

interface PermissionGuardProps {
    resource: string;
    action: string;
    children: ReactNode;
    fallback?: ReactNode;
}

/**
 * Conditionally renders children based on user permissions
 * 
 * @example
 * <PermissionGuard resource="members" action="create">
 *   <Button>Add Member</Button>
 * </PermissionGuard>
 */
export function PermissionGuard({
    resource,
    action,
    children,
    fallback = null,
}: PermissionGuardProps) {
    const { hasPermission, loading } = usePermission();

    // Don't render anything while loading
    if (loading) return null;

    // Check permission
    if (!hasPermission(resource, action)) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
}
